export default function initiateNcellPayment(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'INITIATE_NCELL_PAYMENT_SUCCESS':
      return {...state, ...{success: action.success,error:null}};
    case 'INITIATE_NCELL_PAYMENT_ERROR':
      return {...state, ...{error: action.error.response,success:null}};
    case 'INITIATE_NCELL_PAYMENT_PROCESSING':
      return {...state, ...{processing: action.processing}};
    case 'RESET_INITIATE_NCELL_PAYMENT':
      return {...state, ...{success:null,error:null}};
    default:
      return state;
  }
}
